var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.outDetails.out_ip_data)?_c('app-punch-geolocation-data',{attrs:{"details":_vm.outDetails,"key-data":"out_ip_data"}}):_c('div',[_vm._v("-")])}
var staticRenderFns = []

export { render, staticRenderFns }